import React, { useState, useEffect, useRef } from "react";
import { Routes, Route, Switch, withRouter } from "react-router-dom";
import request from "request"

import CustomAmountModal from "./CustomAmountModal"
import ProductViewHeader from "./ProductViewHeader"
import useProductFiltering from "./useProductFiltering"

import Form from "Form"
import Input from "Input"
import Button from "Button"

const ProductGridView = ({
  products,
  categories,
  selectProduct,
  quickAddProduct,
  isModifyingOrder,
}) => {
  const {
    searchTerm,
    setSearchTerm,
    selectedCategoryId,
    setSelectedCategoryId,
    categoryRefs,
    categoryProducts,
    filteredProducts,
    scrollToCategory,
    activeCategories
  } = useProductFiltering(products, categories)

  return(
    <div className="StoreMenu Grid">
      <ProductViewHeader
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={setSelectedCategoryId}
        activeCategories={activeCategories}
        scrollToCategory={scrollToCategory}
      />

      { activeCategories.map((category, i) => {
        const catProducts = categoryProducts(category.id).filter(p => filteredProducts.includes(p))
        if (catProducts.length === 0) return null

        return(
          <div key={"cat" + i} className="py-2" style={{scrollMarginTop: "40px"}} ref={(el) => categoryRefs.current[category.id] = el}>
            <h3 className="title is-size-4 mb-2"> { category.name } </h3>

            <div className="columns is-flex-wrap-wrap pt-2">
              { catProducts.map((product, i) => {
                const { isActive } = product
                return(
                  <div key={"prod" + i} className={`column is-one-fifth`}>
                    <div
                      className={`product card h-100 ${isActive ? "active" : "inactive"} ${!isActive && "is-disabled"}`}
                      onClick={() => isActive && selectProduct(product.id)}
                    >
                      <img src={product.imageUrl} />
                      <h5 className="title">
                        { product.name }
                      </h5>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ProductGridView


